export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top' style={{backgroundColor:'palevioletred'}}>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='/' style={{fontWeight:'bold', color:'white'}}>
            
           ALLINONE
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
          <li>
              <a href='#about' className='page-scroll'style={{fontWeight:'bold', color:'white'}}>
                About
              </a>
            </li>
          <li>
              <a href='#services' className='page-scroll'style={{fontWeight:'bold', color:'white'}}>
                Services
              </a>
            </li>
            {/* <li>
              <a href='#features' className='page-scroll' style={{fontWeight:'bold', color:'white'}}>
                Features
              </a>
            </li> */}
          
           
            {/* <li>
              <a href='#portfolio' className='page-scroll'style={{fontWeight:'bold', color:'white'}}>
                Gallery
              </a>
            </li> */}
            {/* <li>
              <a href='#testimonials' className='page-scroll'style={{fontWeight:'bold', color:'white'}}>
                Testimonials
              </a>
            </li> */}
            <li>
              <a href='#team' className='page-scroll'style={{fontWeight:'bold', color:'white'}}>
                Team
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll' style={{fontWeight:'bold', color:'white'}}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
